var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-img",style:({
            'background-image': 'url(' + _vm.partnerImage + ')',
        })}),_c('h1',[_vm._v(_vm._s(_vm.JSONParseTranslations(_vm.partner.title, _vm.locale.key)))]),_c('h2',[_vm._v(_vm._s(_vm.JSONParseTranslations(_vm.partner.subtitle, _vm.locale.key)))]),_c('div',{staticClass:"quick-actions"},[_c('q-btn',{attrs:{"size":"16px","icon":"eva-eye-outline","to":{
                name: 'PartnersDetails',
                params: { partnerId: _vm.partner.id },
            }}},[_vm._v(" "+_vm._s(_vm.$t('partners.see_partner'))+" ")]),(_vm.partner.has_courses_button)?_c('q-btn',{attrs:{"size":"16px","icon":"eva-book-outline","to":{
                name: 'Courses',
                params: {
                    partnerId: _vm.partner.id,
                },
            }}},[_vm._v(" "+_vm._s(_vm.$t('partners.see_courses'))+" ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }